var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcAddAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    "data-name": "Component 239 \\u2013 7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "rgba(240,102,73,0.1)",
    stroke: "#ec6321",
    "data-name": "Rectangle 5716"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    stroke: "none",
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    width: 119,
    height: 119,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 9.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17478"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17291"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17290"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#ec6321",
    "data-name": "Group 17289"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.74 90.35c-2.808 0-5.463-.74-7.476-2.081-2.146-1.43-3.328-3.376-3.328-5.478 0-2.101 1.182-4.047 3.328-5.477 2.013-1.342 4.668-2.081 7.477-2.081.73.004 1.46.06 2.18.17V50.177a4.295 4.295 0 0 1 3.02-4.113l.008-.002.01-.003 32.45-9.583a4.306 4.306 0 0 1 3.835.637 4.328 4.328 0 0 1 1.764 3.475v35.71c0 2.102-1.182 4.047-3.328 5.478-2.013 1.342-4.668 2.08-7.477 2.08-2.808 0-5.464-.739-7.477-2.08-2.146-1.431-3.328-3.376-3.328-5.478s1.182-4.047 3.328-5.478c2.013-1.342 4.669-2.08 7.477-2.08.731.003 1.46.06 2.18.169V52.9l-23.838 6.984v22.907c0 2.102-1.182 4.047-3.328 5.478-2.013 1.342-4.668 2.08-7.476 2.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#feefec",
    d: "M79.695 37.347c-.327 0-.656.049-.975.15l-32.46 9.585a3.246 3.246 0 0 0-2.273 3.096v26.519a14.1 14.1 0 0 0-3.246-.398c-5.377 0-9.74 2.907-9.74 6.492s4.363 6.493 9.74 6.493c5.376 0 9.738-2.908 9.738-6.493V59.086l25.97-7.609v18.728a14.04 14.04 0 0 0-3.246-.399c-5.376 0-9.739 2.908-9.739 6.493 0 3.585 4.363 6.492 9.74 6.492 5.376 0 9.738-2.906 9.738-6.492v-35.71a3.246 3.246 0 0 0-3.247-3.242m0-2.132c1.151 0 2.25.36 3.18 1.04a5.397 5.397 0 0 1 2.199 4.333v35.71c0 2.435-1.386 4.755-3.803 6.366-2.186 1.457-5.05 2.26-8.068 2.26-3.017 0-5.882-.803-8.068-2.26-2.417-1.611-3.803-3.931-3.803-6.365s1.386-4.754 3.803-6.365c2.186-1.457 5.051-2.26 8.068-2.26h.012c.368.002.736.017 1.103.044V54.323l-21.707 6.36V82.79c0 2.434-1.386 4.754-3.802 6.365-2.186 1.457-5.052 2.26-8.068 2.26-3.017 0-5.882-.803-8.069-2.26-2.416-1.61-3.802-3.93-3.802-6.365 0-2.433 1.386-4.753 3.802-6.364 2.186-1.458 5.052-2.26 8.069-2.26h.012c.367.002.735.017 1.102.044V50.178a5.357 5.357 0 0 1 3.766-5.13l.035-.01L78.1 35.457a5.37 5.37 0 0 1 1.595-.242z"
  })))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17295"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#ec6321",
    "data-name": "Icon ionic-ios-add-circle"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.415 53.015a13.484 13.484 0 0 1-9.598-3.975 13.484 13.484 0 0 1-3.975-9.598c0-3.626 1.412-7.034 3.975-9.597a13.484 13.484 0 0 1 9.598-3.975c3.626 0 7.035 1.411 9.598 3.975a13.484 13.484 0 0 1 3.975 9.597c0 3.627-1.412 7.035-3.975 9.598a13.484 13.484 0 0 1-9.598 3.975z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#feefec",
    d: "M40.415 26.37c-3.493 0-6.776 1.36-9.244 3.828a12.988 12.988 0 0 0-3.829 9.244c0 3.493 1.36 6.776 3.829 9.245a12.988 12.988 0 0 0 9.244 3.828c3.493 0 6.776-1.36 9.244-3.828a12.988 12.988 0 0 0 3.829-9.245c0-3.492-1.36-6.775-3.829-9.244a12.988 12.988 0 0 0-9.244-3.828m0-1c7.774 0 14.073 6.299 14.073 14.072 0 7.774-6.3 14.073-14.073 14.073-7.774 0-14.073-6.299-14.073-14.073 0-7.773 6.3-14.072 14.073-14.072Z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#feefec"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.89 45.417h-.954a.728.728 0 0 1-.727-.727v-4.043h-4.044a.728.728 0 0 1-.727-.727v-.954c0-.4.326-.727.727-.727h4.044v-4.043c0-.401.326-.727.727-.727h.954c.4 0 .727.326.727.727v4.043h4.043c.4 0 .727.326.727.727v.954c0 .401-.326.727-.727.727h-4.043v4.043c0 .401-.326.727-.727.727z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ec6321",
    d: "M39.936 33.719a.477.477 0 0 0-.477.477v4.293h-4.294a.477.477 0 0 0-.477.477v.954c0 .264.214.477.477.477h4.294v4.293c0 .264.213.477.477.477h.954a.477.477 0 0 0 .477-.477v-4.293h4.293a.477.477 0 0 0 .477-.477v-.954a.477.477 0 0 0-.477-.477h-4.293v-4.293a.477.477 0 0 0-.477-.477h-.954m0-.5h.954c.538 0 .977.438.977.977v3.793h3.793c.539 0 .977.438.977.977v.954a.978.978 0 0 1-.977.977h-3.793v3.793a.978.978 0 0 1-.977.977h-.954a.978.978 0 0 1-.977-.977v-3.793h-3.794a.978.978 0 0 1-.977-.977v-.954c0-.539.439-.977.977-.977h3.794v-3.793c0-.539.438-.977.977-.977z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAddAudio);
export default __webpack_public_path__ + "static/media/ic-add-audio.5be5af8a3b3123ecef50849e97b12702.svg";
export { ForwardRef as ReactComponent };